import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {MainComponent} from "./main/main.component";
import {GraphPageComponent} from "./graph/graph-page/graph-page.component";
import {HeatmapComponent} from "./heatmap/heatmap.component";
import {ProductCatalogComponent} from "./product-catalog/product-catalog.component";
import {ProductPageComponent} from "./product-page/product-page.component";
import {AuthGuardService} from "./shared/services/auth-guard.service";

export const routes: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'product-catalog',
    component: ProductCatalogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'product-page/:collectionId',
    component: ProductPageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'spatial-data',
    component: HeatmapComponent
  },
  /*  {
      path: 'select-stations',
      component: SelectStationsOnMapComponent
    },*/
  {
    path: 'graph',
    component: GraphPageComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
